var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        noBackdropDismiss: _vm.edit,
        position: "bottom",
        maximized: _vm.contentType === "geo",
        "content-classes": "panel mediator"
      },
      on: { hide: _vm.stopAll, show: _vm.hideLoading },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "div",
        { staticClass: "panel-header" },
        [
          _c("q-resize-observable", { on: { resize: _vm.onResize1 } }),
          _vm._v(" "),
          _c("div", { staticClass: "panel-title" }, [
            _c("span", [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]),
            _vm._v(" "),
            _c("small", { staticClass: "text-grey-6" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.fileName) +
                  " (" +
                  _vm._s(_vm.contentType) +
                  "), " +
                  _vm._s(_vm._f("formatSize")(_vm.fileSize)) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-warning" }, [
              _vm._v("\n        " + _vm._s(_vm.groupMessage) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          !_vm.edit && _vm.editEnabled
            ? [
                _c("q-btn", {
                  attrs: {
                    color: "negative",
                    icon: "delete",
                    small: "",
                    round: "",
                    flat: "",
                    title: "Удалить в корзину"
                  },
                  on: { click: _vm.doDelete }
                }),
                _vm._v(" "),
                _c("q-btn", {
                  attrs: {
                    color: "warning",
                    icon: "edit",
                    small: "",
                    round: "",
                    flat: "",
                    title: "Изменить"
                  },
                  on: {
                    click: function($event) {
                      _vm.edit = true
                    }
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.edit && _vm.contentType === "application/pdf"
            ? _c(
                "q-btn",
                {
                  attrs: {
                    color: "positive",
                    small: "",
                    round: "",
                    flat: "",
                    title: "Смотреть"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticStyle: { "text-decoration": "none" },
                      attrs: { href: _vm.url, target: "_blank" }
                    },
                    [
                      _c("q-icon", {
                        attrs: { name: "visibility", color: "positive" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.edit && _vm.contentType !== "geo"
            ? _c(
                "q-btn",
                {
                  attrs: {
                    color: "positive",
                    small: "",
                    round: "",
                    flat: "",
                    title: "Скачать"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticStyle: { "text-decoration": "none" },
                      attrs: { href: _vm.url, download: _vm.name }
                    },
                    [
                      _c("q-icon", {
                        attrs: { name: "file_download", color: "positive" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("q-btn", {
            attrs: {
              title: "Закрыть",
              color: "primary",
              icon: "clear",
              small: "",
              round: "",
              flat: ""
            },
            on: { click: _vm.doCancel }
          }),
          _vm._v(" "),
          _vm.edit
            ? _c("q-btn", {
                attrs: {
                  disabled: _vm.notChanged,
                  color: "positive",
                  icon: "done",
                  small: "",
                  round: "",
                  flat: "",
                  title: "Сохранить"
                },
                on: { click: _vm.doSave }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c(
            "div",
            [
              _c("q-resize-observable", { on: { resize: _vm.onResize2 } }),
              _vm._v(" "),
              _vm.edit
                ? [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          error: _vm.$v.name.$error,
                          "error-label": _vm._f("errorLabel")(_vm.$v.name)
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: { "float-label": "Название" },
                          model: {
                            value: _vm.name,
                            callback: function($$v) {
                              _vm.name =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "q-field",
                      [
                        _c("q-input", {
                          attrs: {
                            type: "textarea",
                            "float-label": "Описание",
                            rows: 1
                          },
                          model: {
                            value: _vm.comment,
                            callback: function($$v) {
                              _vm.comment =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "comment"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-between" },
                      [
                        _vm.contentType != "geo"
                          ? _c("q-checkbox", {
                              attrs: {
                                label: "Доступно оффлайн (на этом устройстве)"
                              },
                              model: {
                                value: _vm.dND,
                                callback: function($$v) {
                                  _vm.dND = $$v
                                },
                                expression: "dND"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.editableFormat
                          ? _c("q-btn", {
                              attrs: {
                                icon: "crop_rotate",
                                color: "primary",
                                small: "",
                                round: "",
                                flat: "",
                                title: "Обрезать/повернуть"
                              },
                              on: { click: _vm.doCropRotate }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : [
                    _vm.comment
                      ? _c("p", [_c("span", [_vm._v(_vm._s(_vm.comment))])])
                      : _vm._e()
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.contentType.indexOf("image") === 0 && _vm.opened
            ? _c("pic-resize", {
                attrs: {
                  maxHeight: _vm.picMaxHeight,
                  url: _vm.url,
                  picIniSize: _vm.fileSize,
                  editableFormat: _vm.editableFormat,
                  maxQuality: _vm.maxQuality
                },
                model: {
                  value: _vm.blob,
                  callback: function($$v) {
                    _vm.blob = $$v
                  },
                  expression: "blob"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.contentType.indexOf("video") === 0
            ? _c("video", {
                style: { maxHeight: _vm.maxHeight },
                attrs: {
                  src: _vm.url,
                  controls: "",
                  id: "v",
                  autoplay: !_vm.edit
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.contentType.indexOf("audio") === 0
            ? _c("audio", {
                attrs: {
                  src: _vm.url,
                  controls: "",
                  id: "a",
                  autoplay: !_vm.edit
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.contentType === "geo"
            ? _c("div", {
                style: { height: _vm.maxHeight },
                attrs: { id: "map" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.slimShow
        ? _c("slim-cropper", {
            ref: "slim",
            attrs: { options: _vm.slimOptions, data: _vm.file }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d20193a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d20193a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mediator.vue
// module id = null
// module chunks = 